

import {Request} from '@/api/request';
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    creatPurchaseOrder,
    getAdminList,
    getOrderCarMountings,
    getOrderCarProject,
    getPurchaseInfo,
    getSupplierList,
    postAddOrderOffer, purchaseEdit, purchaseReturnGoods, returnGoodsEdit
} from "@/api/http";
import {dateformat} from "@/api/date" ;
import {column} from "@/assets/types/common";
import editList from "@/components/editlist/editlist.vue";
import editLista from "@/components/editlista/editlista.vue";
import {useRoute, useRouter} from 'vue-router'
import {validateInput, validateClass} from "@/assets/js/formRules";

type project = {
    id: number;
    project_type_pid: number;
    name: string;
};
type dialogSelect = {
    project_type_pid?: number;
    search?: string;
};
type order = {
    basicset_id: number;
    id: number;
    user_id: number;
    coupon_text: string;
    pay_type: number;
    payment: number;
    order: any;
    order_car: any;
    order_message: any;
    offer: any;
    last_order_id: string;
    next_order_id: string
};

const partsColumn: Array<column> = [
    {
        prop: "name",
        label: "项目名称",
        width: 84,
    },
    {
        prop: "mountings_name",
        label: "配件名称",
        width: 84,
    },
    
    {
        prop: "specification",
        label: "规格",
        width: 84,
    },
    {
        prop: "mountings_type_name",
        label: "配件分类",
        width: 84,
    },
    {
        prop: "mountings_brand_name",
        label: "品牌",
        width: 84,
    },
    {
        prop: "mountings_unit_name",
        label: "单位",
        width: 84,
    },
    {
        prop: "price",
        label: "价格",
        width: 84,
    },
    {
        prop: "stock",
        label: "库存",
        width: 84,
    },
];
const return_cash_plan = {
    return_cash_plan: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                if (value) {
                    callback();
                } else {
                    callback(new Error("请选择返现方案"));
                }
            },
            trigger: "blur",
        },
    ],
};
const partsRules = {
    name: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入配件名称", value, callback);
            },
            trigger: "change",
        },
    ],
    price: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入销售价", value, callback);
            },
            trigger: "change",
        },
    ],
    specification: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入规格", value, callback);
            },
            trigger: "change",
        },
    ],
    encoding: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入编码", value, callback);
            },
            trigger: "change",
        },
    ],
    unit_id: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                if (value) {
                    callback();
                } else {
                    callback(new Error("请选择单位"));
                }
            },
            trigger: "blur",
        },
    ],
    ...return_cash_plan,
};

const formRules = {
    employee_id: [{required: true, message: '必填', trigger: 'change'}],
    supplier_id: [{required: true, message: '必填', trigger: 'change'}],
    date: [{required: true, message: '必填', trigger: 'change'}],
}


export default defineComponent({
    name: "editReturnGoods",
    components: {editList, editLista},
    setup() {
        const setTitle: any = inject("setTitle");
        const headClass = inject("headClass");
        const Router = useRouter();
        let navindex = ref(0),
            type: any = '',
            purchase_id: any = '',
            dialog_show = ref({
                parts: false
            } as any),
            dialogNavIndex = ref(0),
            car_dialog_show = ref(false),
            dialog_data = ref([] as Array<any>),
            dialog_isload = ref(false),
            dialog_search = ref('' as string),
            serviceForm = ref({
                name: "",
                price: null,
                return_cash_plan: null,
            }),
            partsForm = ref({
                ...serviceForm.value,
                encoding: null,
                specification: "",
                unit_id: null,
            }),
            partsFormNode = ref(null),
            partsTable = ref([]),
            dialogSelect = ref({} as dialogSelect),
            serviceTable = ref([]),
            form = ref({
                purchase_type: navindex.value,
                vehicle_id: '',
                employee_id: '',
                supplier_id: '',
                purchase_desc: '',
                purchase_sh: '',
                total_price:'',
                parts: [],
                name: '',
                car_name: '',
                encoding: '',
                specification: '',
                number: '',
                unit_price: '',
                mountings_type_id: '',
                date: new Date().getTime(),
                
            } as any),
            is_all = ref(false),
            serviceDialog = ref(false),
            supplierList = ref([] as any),
            orderDetail = ref({offer: [[], []]} as order),
            selectData: Array<project> = [],
            is_load = ref(false),
            formRef = ref(null),
            PurchaseManList = ref([] as any),
            checkFormData = (): boolean => {
                for (const parts of form.value.parts) {
                    const partsNumber = Number(parts.number);
                    if (partsNumber < 1 || !Number.isInteger(partsNumber)) {
                        alert('退货数量必须为大于等于1的整数')
                        return false;
                    }
                    if (parts.unit_price<0){
                        alert('价格必须大于0')
                        return false;
                    }
                }
                return true;
            },
            _onsubmit = () => {
                if (!checkFormData()) {
                    return;
                }
                form.value.purchase_type = navindex.value,
                    is_load.value = true
                returnGoodsEdit({
                    ...form.value
                }).then((res: any) => {
                    is_load.value = false
                    res.status == 202 && Router.go(-1)
                })
                
            };
        onMounted(() => {
            
            let title = ''
            is_load.value = true
            
            type = useRoute().query.type;
            purchase_id = useRoute().query.id;
            
            title = '退货';
            navindex.value = 4;
            getPurchaseInfo({purchase_id}).then((res: any) => {
                let data = res?.content?.list
                for (let i = 0; i < data.data.length; i++) {
                    data.data[i]['return_number'] = 0
                }
                form.value = {
                    supplier: data.supplier,
                    supplier_id: data.supplier_id,
                    date: data.purchase_time_text,
                    purchase_id: data.purchase_id,
                    employee_id: data.employee_id,
                    purchase_desc: data.purchase_desc,
                    purchase_time: data.create_time,
                    parts: data.data,
                    total_price:data.total_price
                }
                
            })
            
            getAdminList({}).then((res: any) => {
                PurchaseManList.value = res?.content?.list || []
                getSupplierList({status: 1}).then((res: any) => {
                    supplierList.value = res?.content?.list || []
                    is_load.value = false
                })
            })
            setTitle(["采购管理", title]);
        });
        
        
        return {
            navindex,
            dialog_show,
            dialogNavIndex,
            partsRules,
            partsForm,
            partsFormNode,
            partsTable,
            dialogSelect,
            serviceForm,
            headClass,
            is_all,
            partsColumn,
            getOrderCarProject,
            serviceDialog,
            orderDetail,
            selectData,
            serviceTable,
            form,
            PurchaseManList,
            supplierList,
            is_load,
            _onsubmit,
            formRef,
            formRules,
            type,
            car_dialog_show,
            dialog_data,
            dialog_isload,
            dialog_search,
            purchase_id
        };
    },
});
